import PropTypes from 'prop-types'

import {BASE_CLASS} from '../settings.js'

export const ColorCircle = ({color, size = 'medium'}) => {
  const background = `linear-gradient(135deg, ${color}50 12.46%, ${color} 56.67%)`
  return <div className={`${BASE_CLASS}-colorCircle ${BASE_CLASS}-colorCircle--${size}`} style={{background}} />
}

ColorCircle.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium'])
}
